<template>
    <nav class="pagination" role="navigation" aria-label="pagination">
        <a class="pagination-next">&nbsp;</a>
        <a class="pagination-previous">&nbsp;</a>
        <ul class="pagination-list">
            <li><a class="pagination-item" aria-label="Goto page 1">1</a></li>
            <li><span class="pagination-ellipsis">&hellip;</span></li>
            <li><a class="pagination-item" aria-label="Goto page 45">45</a></li>
            <li><a class="pagination-item is-current" aria-label="Page 46" aria-current="page">46</a>
            </li>
            <li><a class="pagination-item" aria-label="Goto page 47">47</a></li>
            <li><span class="pagination-ellipsis">&hellip;</span></li>
            <li><a class="pagination-item" aria-label="Goto page 86">86</a></li>
        </ul>
    </nav>
</template>

<script>
    export default {
        name: "CatUxoPagination",
        mounted() {
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/shared/Pagination.vue